import {
  OpportunitiesPipelinesListData,
  opportunitiesPipelinesListInfiniteOptions,
  OpportunitiesStatusesListData,
  opportunitiesStatusesListInfiniteOptions,
  OpportunityPipelineReadable,
  PaginatedReturnOpportunityPipelineNomenclatorListReadable,
  PaginatedReturnOpportunityStatusListReadable,
  ReturnOpportunityStatusReadable
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { listTransformResults } from '@crm/utils'
import { FormColorPicker } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Checkbox, Form, FormInstance, Input } from 'antd'

type Props = {
  form: FormInstance
}

export const FormNomenclaturesStatus = ({ form }: Props) => {
  const { t } = useLocales()

  const pipeline = Form.useWatch('pipeline', form)

  return (
    <>
      <Form.Item
        name="name"
        label={t('nomenclature.name')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="code"
        label={t('nomenclature.code')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <FormColorPicker
        itemProps={{
          label: t('nomenclature.color')
        }}
        showText
      />

      <Form.Item
        name="order"
        label={t('nomenclature.order')}
        rules={[{ required: true }]}
      >
        <Input type="number" />
      </Form.Item>

      <Form.Item name="pipeline" label={t('contacts.pipeline')}>
        <InfiniteSelect<
          OpportunitiesPipelinesListData,
          PaginatedReturnOpportunityPipelineNomenclatorListReadable,
          OpportunityPipelineReadable
        >
          popupMatchSelectWidth
          placeholder={undefined}
          getQueryFunction={opportunitiesPipelinesListInfiniteOptions}
          getOptions={({ options }) => listTransformResults(options)}
          baseOptions={{
            query: {
              preference: pipeline ? [pipeline] : undefined
            }
          }}
        />
      </Form.Item>

      <Form.Item
        name="allowed_transition_statuses"
        label={t('nomenclature.allowed_transition_status_codes')}
        tooltip={t('nomenclature.allowed_transition_status_codes_hint')}
      >
        <InfiniteSelect<
          OpportunitiesStatusesListData,
          PaginatedReturnOpportunityStatusListReadable,
          ReturnOpportunityStatusReadable
        >
          mode="multiple"
          popupMatchSelectWidth
          placeholder={t('main.select')}
          getQueryFunction={opportunitiesStatusesListInfiniteOptions}
          baseOptions={{
            query: { pipeline: pipeline ? Number(pipeline) : undefined }
          }}
          getOptions={({ options }) =>
            options.map(({ id, name }) => ({ value: id, label: name }))
          }
        />
      </Form.Item>

      <Form.Item
        name="requires_refusal_reason"
        label={t('nomenclature.requires_refusal_reason')}
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox />
      </Form.Item>

      <Form.Item
        name="requires_contract"
        label={t('nomenclature.requires_contract')}
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox />
      </Form.Item>

      <Form.Item
        name="is_default"
        label={t('nomenclature.is_default')}
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox />
      </Form.Item>
    </>
  )
}
